import { useState, useEffect } from "react";
import * as WorkingPartService from "../../../../services/WorkingPartService";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import UserForm from "../userForm";
import ChangePassword from "../changePasswForm";

import { ShowAlertDialog } from "@de-prado-dev/react-component-library";

export const useUser = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  useEffect(() => {
    // StopServices.getLastStop().then((result) => {
    //   setLastStop(result);
    // });
  }, []);

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const addUser = async () => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <UserForm
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                ></UserForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const changePasswordUser = async (userUuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <ChangePassword
                  uuid={userUuid}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                ></ChangePassword>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const updatePart = async (isTechnical, workingPartUuid) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-3">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row">
              <div className="col-12">
                <UserForm
                  uuid={workingPartUuid}
                  isTechnical={isTechnical}
                  onCancel={() => handlerClosePopup("ModalForm")}
                  onSuccess={() => {
                    handlerClosePopup("ModalForm");
                    if (refresh) {
                      refresh();
                    }
                  }}
                  // toEdit={stop}
                  // custom
                ></UserForm>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  const deletePart = async (isTechnical, workingPartUuid) => {
    const okAction = async () => {
      WorkingPartService.deleteWorkingPart(workingPartUuid).then((result) => {
        if (result && result.deleted === true) {
          if (refresh) {
            refresh();
          }
        }
      });
    };

    const cancelAction = () => {};

    ShowAlertDialog(
      t("forms.workingPart.dialog.remove.title"),
      t("forms.workingPart.dialog.remove.text"),
      "warning",
      true,
      t("forms.workingPart.dialog.remove.buttonOk"),
      false,
      okAction,
      t("forms.workingPart.dialog.remove.buttonNo"),
      cancelAction,
      "#6ec1e4"
    );
  };

  return {
    addUser,
    changePasswordUser,
    updatePart,
    deletePart,
  };
};
